import * as React from "react";
import { Grid, Divider, Typography } from "@mui/material";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import "../../../index.css";

export const ResultFiles = ({ downloadCSVFile }) => {
  const forntStyle = {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#7b92dc",
    fontFamily: "DM Sans, sans-serif",
  };

  const resultTextArray = [
    "Leakage Detection",
    "Condenser Fouling",
    "Cond Fouling All Bins",
    "Cond Fouling Trend",
    "Evaporator Fouling",
    "Threshold Analysis",
  ];

  return (
    <Grid
      container
      sx={{
        width: "100%",
        padding: "0.1rem",
        borderRadius: "8px",
        paddingTop: "0rem",
      }}
    >
      <Grid
        item
        xs={8}
        sx={{ padding: "0", display: "flex", alignItems: "center" }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "0.9375rem",
            fontFamily: "DM Sans, sans-serif",
            margin: "0px",
            padding: "0px",
            lineHeight: "0",
            display: "flex",
            alignItems: "center",
            paddingTop: "0rem",
          }}
        >
          Result files
        </Typography>
      </Grid>

      <Grid item xs={12} sx={{ padding: "0" }}>
        {resultTextArray.map((text, index) => (
          <React.Fragment key={index}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              sx={{
                width: "100%",
                paddingY: "0.4rem",
                margin: "0px",
                cursor: "pointer",
                transition: "background 0.3s ease-in-out",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                },
              }}
              onClick={() => downloadCSVFile(text)}
            >
              <Typography sx={forntStyle}>{text}</Typography>
              <DownloadForOfflineIcon
                className="dowloadButtonStyle"
                sx={{
                  cursor: "pointer",
                  color: "#47a00a",
                  transition: "color 0.2s ease-in-out",
                  "&:hover": {
                    color: "#2c6e00",
                  },
                }}
              />
            </Grid>
            {index !== resultTextArray.length - 1 && (
              <Divider sx={{ backgroundColor: "#ccc", margin: "0" }} />
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
};
